module.exports = __webpack_public_path__ + "img/edit.ea7a30d2.svg";